<template>
    <section class="side-panel-section">
        <div class="header-line grid-container">
            <div id="closeIcon">
                <ds-icon-button
                    slot="leading"
                    name="arrow-left"
                    data-qa="close-button"
                    @click="backToContactInfo"
                />
            </div>

            <div class="contact-layout-header">
                <h3 class="profile-label grid-item">
                    Custom layouts
                </h3>

                <p class="layouts-body">
                    Contact record
                </p>
            </div>

            <ds-icon-button
                class="add-icon"
                name="add-circle"
                @click="showLayoutModal(null)"
            />
        </div>

        <section class="table-scroller">
            <div class="layouts-list">
                <table class="layouts-details">
                    <tr
                        :class="['layout-details', { active : activeLayout === 'Everything layout' }]"
                        @click="getLayoutDetails(everyThingLayout)"
                    >
                        <td style="width: 5%">
                            <ds-icon name="business-card" />
                        </td>

                        <td style="width: 80%">
                            <div class="layouts-title">
                                <div class="title">
                                    Everything layout
                                </div>

                                <p class="layouts-body">
                                    Non-editable system layout
                                </p>
                            </div>
                        </td>

                        <td>
                            <ds-dropdown class="dropdown" position="bottom-end">
                                <ds-icon-button class="icon-only">
                                    <ds-icon data-qa="drop-down" name="more-vertical" />
                                </ds-icon-button>

                                <div slot="menu">
                                    <ul
                                        class="dropdown-menu-list"
                                    >
                                        <li
                                            class="dropdown-menu-item"
                                            @click="copyLayoutModal(everyThingLayout)"
                                        >
                                            <ds-icon name="copy" />

                                            <div class="menu-item-icon-delete">
                                                Copy layout
                                            </div>
                                        </li>
                                        <li
                                            class="dropdown-menu-item"
                                            @click="setAsDefaultLayout(everyThingLayout)"
                                        >
                                            <ds-icon name="check-square" />

                                            <div class="menu-item-icon">
                                                Set as default
                                            </div>
                                        </li>
                                        <li
                                            class="dropdown-menu-item dropdown-menu-item-readonly"
                                            data-qa="delete-contact"
                                        >
                                            <ds-icon name="trash-2" />

                                            <div class="menu-item-icon-delete">
                                                Delete
                                            </div>

                                            <p class="cannot-delete">
                                                This layout and cannot be deleted
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </ds-dropdown>
                        </td>
                    </tr>
                    <tr
                        v-for="(layout, i) in contactLayouts"
                        :key="i"
                        :class="['layout-details', { active : activeLayout === layout.name }]"
                        @click="getLayoutDetails(layout)"
                    >
                        <td style="width: 5%">
                            <ds-icon name="business-card" />
                        </td>

                        <td style="width: 70%">
                            <div class="layouts-title">
                                <div class="title">
                                    {{ layout.name }}
                                </div>

                                <p class="layouts-body">
                                    Fully customizable layout
                                </p>
                            </div>
                        </td>

                        <td class="more-options">
                            <ds-dropdown class="dropdown" position="bottom-end">
                                <ds-icon-button id="contactInfoHeaderControlsIcon" class="icon-only">
                                    <ds-icon data-qa="drop-down" name="more-vertical" />
                                </ds-icon-button>

                                <div slot="menu">
                                    <ul
                                        class="dropdown-menu-list"
                                    >
                                        <li
                                            class="dropdown-menu-item"
                                            @click="showLayoutModal(layout)"
                                        >
                                            <ds-icon name="edit" />

                                            <div class="menu-item-icon">
                                                Rename
                                            </div>
                                        </li>

                                        <li
                                            class="dropdown-menu-item"
                                            @click="copyLayoutModal(layout)"
                                        >
                                            <ds-icon name="copy" />

                                            <div class="menu-item-icon">
                                                Copy layout
                                            </div>
                                        </li>

                                        <li
                                            class="dropdown-menu-item"
                                            @click="openLayoutDeleteConfirmModal(layout)"
                                        >
                                            <ds-icon name="trash-2" />

                                            <div class="menu-item-icon">
                                                Delete
                                            </div>
                                        </li>

                                        <li
                                            class="dropdown-menu-item"
                                            @click="setAsDefaultLayout(layout)"
                                        >
                                            <ds-icon name="check-square" />

                                            <div class="menu-item-icon">
                                                Set as default
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </ds-dropdown>
                        </td>
                    </tr>
                </table>
            </div>
        </section>

        <ds-modal
            :is-open="isLayoutModalOpen"
            :title.sync="modalTitle"
            show-close
            :user-id="userId"
            @close="modalClose"
        >
            <template #header>
                <ds-button
                    @click="contactLayoutAction"
                >
                    Save
                </ds-button>
            </template>

            <template #default>
                <div>
                    <ds-input-field
                        v-model="addLayoutName"
                        class="layout-popup"
                        label="label"
                        submitted
                        required
                    />
                    <div>
                        <span class="errorMessage">{{ layoutErrorMessage }}</span>
                    </div>
                </div>
            </template>
        </ds-modal>

        <ds-confirm-dialog
            :is-open="isDeleteLayoutConfirmModalOpen"
            title="Delete layout?"
            :message="deleteLayoutNameMessage"
            message-class="min"
            cancel-button-class="cancel"
            cancel-label="Cancel"
            confirm-label="Delete layout"
            confirm-button-class="negative"
            @confirm="verifyAndSetDefaultLayout"
            @cancel="confirmLayoutModalCancel"
        />
    </section>
</template>
<script>
import axios from 'axios';

export default {
    props: {
        userId: [String, Number],
        contactLayoutsList: Array,
        defaultLayoutId: [String, Number],
    },

    data() {
        return {
            layoutId: 0,
            contactLayouts: [],
            contactLayout: {},
            layoutErrorMessage: '',
            addLayoutName: '',
            layoutName: '',
            modalTitle: 'Add a new layout',
            everyThingLayout: {
            },
            load: false,
            data: 0,
            deleteLayoutNameMessage: '',
            sendDefaultLayout: {},
            layoutDetails: {},
            contactlayoutAssignedUsers: [],
            activeLayout: 'Everything layout',
            isLayoutModalOpen: false,
            isDeleteLayoutConfirmModalOpen: false,
        };
    },

    created() {
        this.contactLayouts = this.contactLayoutsList;
        this.getContactLayouts();
        this.sendDefaultLayoutId = false;
        this.sendDefaultLayout.layoutId = this.defaultLayoutId;
    },

    mounted() {
        this.$root.$on('BUTTON_ADD_LAYOUT', (data) => {
            if (data) {
                this.showLayoutModal(null);
            }
        });

        this.$root.$on('UPDATE_CONTACT_LAYOUT_LIST', (contactCustomLayoutsList) => {
            this.contactLayouts = contactCustomLayoutsList;
            this.getContactLayouts();
        });

        this.$root.$on('COPY_EVERYTHING_LAYOUT', (everthingLayoutObj) => {
            this.copyLayoutModal(everthingLayoutObj);
        });
    },

    beforeDestroy() {
        this.$root.$off('UPDATE_CONTACT_LAYOUT_LIST');
        this.$root.$off('BUTTON_ADD_LAYOUT');
        this.$root.$off('COPY_EVERYTHING_LAYOUT');
    },

    methods: {
        getContactLayouts() {
            const everthinglayoutObj = this.contactLayouts[0];

            this.everyThingLayout = everthinglayoutObj;

            this.contactLayouts.splice(0, 1);
        },

        confirmLayoutModalCancel() {
            this.isDeleteLayoutConfirmModalOpen = false;
            this.layoutId = 0;
        },

        openLayoutDeleteConfirmModal(layout) {
            this.layoutId = layout.id;

            this.contactlayoutAssignedUsers = layout.assignedUsers;
            this.deleteLayoutNameMessage = 'This action only deletes the layout and the headers and tabs within the layout, the fields within the layout will NOT be deleted.';
            this.isDeleteLayoutConfirmModalOpen = true;
        },

        backToContactInfo() {
            this.sendDefaultLayout.contactList = this.contactLayouts;
            this.sendDefaultLayout.actionItem = false;
            this.$root.$emit('CUSTOMIZED_CONTACT_RECORD_LAYOUT_DETAILS', this.sendDefaultLayout);
        },

        async contactLayoutAction() {
            try {
                let isTabNameExists = false;

                this.contactLayouts.forEach((contactLayout) => {
                    if (contactLayout.name === this.addLayoutName) {
                        isTabNameExists = true;
                    }
                });

                if (isTabNameExists) {
                    this.layoutErrorMessage = 'This layout name already exists. Please select a unique layout name.';
                } else {
                    let successMessage = '';

                    if (this.contactLayout.id > 0) {
                        this.contactLayout.name = this.addLayoutName;
                        this.contactLayout.lastUpdatedBy = this.userId;
                        successMessage = 'update contact Layout';
                    } else {
                        this.contactLayout = {};
                        this.contactLayout.id = 0;
                        this.contactLayout.name = this.addLayoutName;
                        this.contactLayout.createdBy = this.userId;
                        this.contactLayout.active = true;
                        const usersList = [];

                        usersList.push(Number(this.userId));

                        this.contactLayout.assignedUsers = usersList;

                        successMessage = 'added contact Layout';
                    }

                    if (this.contactLayout.id > 0) {
                        await axios.post('/app/contactLayout/layout/save', this.contactLayout);
                    } else {
                        await axios.post('/app/contactLayout', this.contactLayout);
                    }

                    this.$toast({ message: successMessage });

                    if (this.contactLayout.id === 0) {
                        this.$root.$emit('LAYOUT_LIST_DISPLAY', this.addLayoutName);
                    } else {
                        this.getLayoutDetails(this.contactLayout);
                    }
                    this.isLayoutModalOpen = false;
                }
            } catch (error) {
                this.$error({ message: 'error occurred while adding contactLayoutList' });
            }
        },

        async copyLayoutModal(layout) {
            try {
                this.layoutDetails = layout;
                this.layoutDetails.id = 0;
                const layoutName = `Copy of ${this.layoutDetails.name}`;

                let isLayoutNameExists = false;

                this.contactLayouts.forEach((contactLayout) => {
                    if (contactLayout.name === layoutName) {
                        isLayoutNameExists = true;
                    }
                });

                if (isLayoutNameExists) {
                    this.layoutDetails.name = `Copy of ${layoutName}`;
                } else {
                    this.layoutDetails.name = layoutName;
                }
                this.layoutDetails.createdBy = this.userId;
                this.layoutDetails.active = true;

                const usersList = [];

                usersList.push(Number(this.userId));

                this.layoutDetails.assignedUsers = usersList;

                if (layout.name !== 'Everything Layout') {
                    if (this.layoutDetails.layoutComponents && this.layoutDetails.layoutComponents.length > 0) {
                        this.layoutDetails.layoutComponents.forEach((tabData) => {
                            tabData.id = 0;

                            if (tabData.components && tabData.components.length > 0) {
                                tabData.components.forEach((headerComponents) => {
                                    headerComponents.id = 0;
                                    headerComponents.components.forEach((fieldsComponents) => {
                                        fieldsComponents.id = 0;
                                    });
                                });
                            }
                        });
                    }
                }
                await axios.post('/app/contactLayout/layout/save', this.layoutDetails);
                this.$toast({ message: 'Copied Layout Successfully' });
                this.$root.$emit('LAYOUT_LIST_DISPLAY', this.layoutDetails.name);
                this.layoutDetails = {};
            } catch (error) {
                this.$error({ message: 'error occurred while copy layout' });
            }
        },

        async setAsDefaultLayout(layout) {
            try {
                await axios.put(`/app/contact/saveAppSettingContactLayout?userId=${this.userId}&layoutId=${layout.id}`);

                this.$toast({ message: 'layout setted as Default' });
                this.sendDefaultLayout.layoutId = layout.id;

                if (this.sendDefaultLayoutId) {
                    this.$root.$emit('DELETE_LAYOUT', this.sendDefaultLayout);
                } else {
                    this.$root.$emit('LAYOUT_DISPLAY', layout);
                }
            } catch (error) {
                this.$error({ message: 'error occurred while setting default layout ' });
            }
        },

        modalClose() {
            this.contactLayout = {};
            this.isLayoutModalOpen = false;
        },

        getLayoutDetails(layout) {
            this.activeLayout = layout.name;
            this.$root.$emit('LAYOUT_DISPLAY', layout);
        },

        async verifyAndSetDefaultLayout() {
            try {
                const contactlayoutAssignedUsersData = {
                    contactLayoutId: 0,
                    userIds: [],
                };

                contactlayoutAssignedUsersData.contactLayoutId = Number(this.layoutId);
                contactlayoutAssignedUsersData.userIds.push(...this.contactlayoutAssignedUsers);
                await axios.put('/app/contact/setDefault/', contactlayoutAssignedUsersData);

                this.isDeleteLayoutConfirmModalOpen = false;

                this.deleteLayout();
            } catch (error) {
                this.$error({ message: 'error occurred while removing layout' });
            } finally {
                this.contactlayoutAssignedUsers = [];
            }
        },

        async deleteLayout() {
            const successMessage = 'layout deleted successfully';

            try {
                await axios.delete(`/app/contactLayout/${this.layoutId}`);

                this.$toast({ message: successMessage });

                const isIndex = this.contactLayouts.findIndex((layout) => layout.id === Number(this.layoutId));

                if (isIndex !== -1) {
                    this.contactLayouts.splice(isIndex, 1);
                }
                this.contactLayout = {};

                if (this.defaultLayoutId === this.layoutId) {
                    this.setDefaultLayout = true;
                    this.setAsDefaultLayout(this.everyThingLayout);
                } else {
                    this.$root.$emit('LAYOUT_LIST_DISPLAY', 'default');
                }
            } catch (error) {
                this.$error({ message: 'error occurred while deleting layout' });
            }
        },

        showLayoutModal(layout) {
            if (layout !== null) {
                this.modalTitle = 'Edit layout';
                this.contactLayout = layout;
                this.addLayoutName = layout.name;
            } else {
                this.addLayoutName = '';
                this.modalTitle = 'Add a new layout';
            }
            this.layoutErrorMessage = '';
            this.isLayoutModalOpen = true;
        },
    },
};

</script>

<style lang="scss" scoped>
#closeIcon {
    margin-right: $spacing-100;
}

.contact-layout-header {
    border-collapse: collapse;
    width: 75%;
}

.cannot-delete {
    font-size: 0.70rem;
    margin-bottom: -1.6rem;
    margin-left: -$spacing-600;
    color: $color-gray-darker;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dropdown-menu-list {
    white-space: pre-wrap
}

.menu-item-icon {
    margin: $spacing-050;
}

.menu-item-icon-delete {
    margin: -$spacing-050;
    padding: 0 0 $spacing-200;
}

.layouts-body {
    font-size: $font-size-xs;
    color: $color-gray-darker;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.add-icon {
    color: $color-black;
    cursor: pointer;
    width: 15%;
}

.horiz {
    border: 0.5px solid #b5b5b5;
}

.layouts-details {
    cursor: pointer;
    border-collapse: collapse;
    border-top: 1px solid $color-gray-lighter;
    width: 100%;
    display: block;
}

.layout-details:hover {
    background-color: $color-gray-050;
}

.layout-details.active {
    background-color: $color-gray-100;
}

.layouts-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    align-items: center;
}

.title {
    font-size: $font-size-md;
    margin-top: $spacing-100;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.header-line {
    width: 100%;
    border-bottom: 1px solid #e7e7e7;
    padding: 1rem 1rem 0;
}

.more-options {
    float: right;
}

.grid-container {
    display: flex;
    align-items: start;
    margin-top: $spacing-200;
}

.grid-item {
    margin: auto;
}

.profile-label {
    margin-left: 0;
}

@media only screen and ($medium-down) {
    .layouts-body {
        white-space: nowrap;
        width:  12.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
    }

}

.dropdown-menu-item-readonly {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.6;
}

.layout-details {
    -webkit-transition: background-color .25s cubic-bezier(.23, 1, .32, 1);
    transition: background-color .25s cubic-bezier(.23, 1, .32, 1);
    color: #000;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.table-scroller {
    overflow-y: auto;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow-x: hidden;
}

.table-scroller::-webkit-scrollbar {
    display: none;
}

.table-scroller {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.errorMessage {
    color: $color-red;
}

.layout-popup {
    margin-bottom: 0 !important;
}

@media only screen and ($small) {
    .vert {
        border: 0.5px solid $color-gray-light;
    }
}

.side-panel-section {
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.layouts-list{
    min-width: 22.5rem;
}
</style>
